import { globalHistory } from '@gatsbyjs/reach-router';
import React, { useContext, useEffect, useState } from 'react';
import { enrollmentContext } from '../../../../../../hoc/context/enrollment/enrollment-context';
import { DefaultQuestion, DefaultQuestionProps } from '../default/default';

interface ServiceQuestionProps extends DefaultQuestionProps {}

export const ServiceQuestion = ({
	question,
	answer,
	answerQuestion,
}: ServiceQuestionProps) => {
	const enrollmentCtxt = useContext(enrollmentContext);
	const [services, setServices] = useState<Set<string>>(new Set<string>());
	useEffect(() => {
		if (question.choices) {
			const servicesSet = new Set<string>();
			question.choices?.forEach((choice) =>
				(choice.value as string)
					.split(',')
					.forEach((splitted) => servicesSet.add(splitted))
			);
			setServices(servicesSet);
		}
		//TODO - below fix will cause issue if discarded service is being added on
		// different functionality other than next button, need to refactor below
		// code later
		return globalHistory.listen(({ action }) => {
			if (action === 'POP') {
				enrollmentCtxt.input.discardedServices = [];
			}
		});
	}, [question]);

	const serviceSelected = (choice: string) => {
		const selectedServices = choice.split(',');
		enrollmentCtxt.addDiscardedService(
			[...services].filter((service) => !selectedServices.includes(service))
		);
		if (choice) {
			enrollmentCtxt.removeDiscardedService(selectedServices);
		}
	};
	return (
		<>
			<DefaultQuestion
				question={question}
				answer={answer}
				answerQuestion={(inputAnswer: string) => {
					serviceSelected(inputAnswer);
					answerQuestion(inputAnswer);
				}}
			/>
		</>
	);
};
